import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  HostBinding,
  AfterViewInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MStepper } from '@argalis-apps/angular-global';
import { UserService } from '@argalis-apps/angular-services';
import { AuthService } from '../../../auth/services/auth/auth.service';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { of } from 'rxjs';
import { distinctUntilChanged, throttleTime } from 'rxjs/operators';
import { ProfileInformationsService } from '../../../account/services/profile-informations/profile-informations.service';
import { MUser } from '@argalis-apps/models';

const companyFormConfig = {
  civ: [null],
  nom: [null, Validators.required],
  prenom: [null, Validators.required],
  role: [null],
  phone: [null, Validators.pattern(/^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}/)],
  mobile: [null, Validators.pattern(/^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}/)],
  // adresse: [null, Validators.required],
  // code_postal: [null, Validators.pattern(/^[0-9]\d{4}/)],
  // ville: [null, Validators.required],
  raisonSociale: [null, Validators.required],
  typeEntreprise: [null, Validators.required],
  siret: [null, Validators.required],
  tva: [null, Validators.required]
  //  cgv: [null, Validators.requiredTrue] TODO REMOVE Commentaire when CGV function avaible
};

const userFromConfig = {
  civ: [null],
  nom: [null, Validators.required],
  prenom: [null, Validators.required],
  role: [null],
  adresse: [null, Validators.required],
  code_postal: [null, Validators.pattern(/^[0-9]\d{4}/)],
  ville: [null, Validators.required],
  phone: [null, Validators.pattern(/^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}/)],
  mobile: [null, Validators.pattern(/^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}/)]
  // cgv: [null, Validators.requiredTrue], TODO REMOVE Commentaire when CGV function avaible
};

@Component({
  selector: 'ags-commanditaire',
  templateUrl: './commanditaire.component.html',
  styleUrls: ['./commanditaire.component.scss']
})
export class CommanditaireComponent implements OnInit, MStepper.IStepComponent {
  @HostBinding('class') themeFlag: string;
  @Input() public step: MStepper.IStep;
  @Output() public backStep = new EventEmitter<any>();
  @Output() public validation = new EventEmitter<any>();
  public typeClient: string;
  public errorMsg: string;
  public displayPopup = false;
  public existSiren = false;
  public submitted = false;
  public loading = false;
  public errorUpdate = false;
  public formCompanyInformations: UntypedFormGroup;
  public formUserInformations: UntypedFormGroup;
  public listCiv: string[] = ['M.', 'Mme'];
  public listTypeClient: string[] = ['responsable de formation', 'un particulier / indépendant'];
  public listTypeEntreprise: { id: number; libelle: string; code: string }[] = [];
  public openeUpdateDialog = false;
  public userConnectedInfo: MUser.CUser;
  constructor(
    private formCompanyBuilder: UntypedFormBuilder,
    private formUserInfoBuilder: UntypedFormBuilder,
    private userService: UserService,
    private authService: AuthService,
    private router: Router,
    private profilInformationsService: ProfileInformationsService,
    private cartConfigService: CartConfigService
  ) {
    if (!this.authService.userConnected) return this.noUserConnected(this);
    this.themeFlag = `${this.themeFlag || ''} ${this.cartConfigService.themingClassName}`;
    this.userService.getClientType().subscribe((clientTypes: { id: number; libelle: string; code: string }[]) => {
      this.listTypeEntreprise = clientTypes.filter(
        (cType: { id: number; libelle: string; code: string }) => cType.code !== 'PART'
      );
      this.formDataInit();
    });
    this.typeClient = this.authService.userConnected.company.type;
    this.userConnectedInfo = this.authService.userConnected;
  }

  ngOnInit(): void {}

  public clientTypeChange(newClientType: string) {
    if (!this.authService.userConnected) return this.noUserConnected();

    if (newClientType === 'un particulier / indépendant') {
      this.authService.userConnected.company.type = 'PART';
      this.userConnectedInfo = this.authService.userConnected;
    } else {
      this.authService.userConnected.company.type = null;
      this.userConnectedInfo = this.authService.userConnected;
    }
    this.formDataInit();
  }

  private noUserConnected(returnValue: any = false) {
    this.router.navigate(this.authService.getRoute('signup'));
    return returnValue;
  }

  private formCompanyValue(formControleName: string, value) {
    if (formControleName && value) {
      const ctrl = this.formCompanyInformations.get(formControleName);
      if (ctrl) {
        ctrl.setValue(value);
      }
    }
  }
  private formSetUserValue(formControleName: string, value) {
    if (formControleName && value) {
      const ctrl = this.formUserInformations.get(formControleName);
      if (ctrl) {
        ctrl.setValue(value);
      }
    }
  }

  private initCompanyFormData() {
    this.formCompanyValue('civ', this.authService.userConnected.userInfo.civ);
    this.formCompanyValue('nom', this.authService.userConnected.userInfo.name);
    this.formCompanyValue('prenom', this.authService.userConnected.userInfo.firstName);
    this.formCompanyValue('role', this.authService.userConnected.userInfo.role);
    this.formCompanyValue('phone', this.authService.userConnected.userInfo.phone);
    this.formCompanyValue('mobile', this.authService.userConnected.userInfo.mobile);
    this.formCompanyValue('role', this.authService.userConnected.userInfo.role);
    // if (this.authService.userConnected.userInfo.addr) {
    //   this.formCompanyValue('adresse', this.authService.userConnected.userInfo.addr.addr);
    //   this.formCompanyValue('code_postal', this.authService.userConnected.userInfo.addr.postal);
    //   this.formCompanyValue('ville', this.authService.userConnected.userInfo.addr.city);
    // }
    this.formCompanyValue('raisonSociale', this.authService.userConnected.company.name);

    this.formCompanyValue(
      'typeEntreprise',
      this.listTypeEntreprise.find(
        (typeEntreprise: { id: number; libelle: string; code: string }) =>
          (typeEntreprise.id || '1').toString() === this.authService.userConnected.company.type
      )
    );
    this.formCompanyValue('siret', this.authService.userConnected.company.siren);
    this.formCompanyValue('tva', this.authService.userConnected.company.tva);
    // this.formCompanyValue('cgv', false);
  }

  private initUserFormData() {
    this.formSetUserValue('civ', this.authService.userConnected.userInfo.civ);
    this.formSetUserValue('nom', this.authService.userConnected.userInfo.name);
    this.formSetUserValue('prenom', this.authService.userConnected.userInfo.firstName);
    this.formSetUserValue('role', this.authService.userConnected.userInfo.role);
    this.formSetUserValue('phone', this.authService.userConnected.userInfo.phone);
    this.formSetUserValue('mobile', this.authService.userConnected.userInfo.mobile);
    if (this.authService.userConnected.userInfo.addr) {
      this.formSetUserValue('adresse', this.authService.userConnected.userInfo.addr.addr);
      this.formSetUserValue('code_postal', this.authService.userConnected.userInfo.addr.postal);
      this.formSetUserValue('ville', this.authService.userConnected.userInfo.addr.city);
    }
    //this.formSetUserValue('cgv', false);
  }

  formDataInit() {
    if (!this.authService.userConnected) return this.noUserConnected();
    if (this.authService.userConnected.company.type === 'PART') {
      this.typeClient = 'un particulier / indépendant';
      this.formUserInformations = this.formUserInfoBuilder.group(Object.assign({}, userFromConfig));
      this.initUserFormData();
    } else {
      this.typeClient = 'responsable de formation';
      this.formCompanyInformations = this.formCompanyBuilder.group(Object.assign({}, companyFormConfig));
      this.initCompanyFormData();
    }
  }

  formUpdateCompany() {
    this.submitted = true;
    if (!this.formCompanyInformations.invalid) {
      if (this.existSiren) {
        this.openeUpdateDialog = true;
        this.submitted = false;
      } else {
        this.loading = true;
        const user = this.authService.userConnected;
        const company = {
            id: user['company']['id'],
            name: this.formCompanyInformations.value['raisonSociale'],
            siren: this.formCompanyInformations.value['siret'],
            type: (this.formCompanyInformations.value['typeEntreprise'] as {
              id: string;
              libelle: string;
              code: string;
            }).id,
            tva: this.formCompanyInformations.value['tva'].toString()
          },
          userInfo = {
            id: user['userInfo']['id'],
            civ: this.formCompanyInformations.value['civ'],
            firstName: this.formCompanyInformations.value['prenom'],
            name: this.formCompanyInformations.value['nom'],
            role: this.formCompanyInformations.value['role'],
            phone: this.formCompanyInformations.value['phone'],
            mobile: this.formCompanyInformations.value['mobile']
            // addr: {
            //   addr: this.formCompanyInformations.value['adresse'],
            //   postal: this.formCompanyInformations.value['code'],
            //   city: this.formCompanyInformations.value['ville']
            // }
          },
          updateInfo = { company: company, userInfo: userInfo };
        this.profilInformationsService.updateProfileInformationsToServer(updateInfo).subscribe(
          () => {
            this.loading = false;
            this.submitted = true;
            this.nextStep();
          },
          () => this.displayError()
        );
      }
    }
  }

  displayError() {
    this.errorUpdate = true;
    this.loading = false;
    this.submitted = false;
    this.openeUpdateDialog = true;
    this.errorMsg = `Une erreur est survenue, réessayez plus tard`;
  }

  formUpdateUser() {
    this.submitted = true;
    if (!this.formUserInformations.invalid) {
      this.loading = true;
      const user = this.authService.userConnected;
      const updateInfo = {
        id: user['userInfo']['id'],
        civ: this.formUserInformations.value['civ'],
        firstName: this.formUserInformations.value['prenom'],
        name: this.formUserInformations.value['nom'],
        role: this.formUserInformations.value['role'],
        phone: this.formUserInformations.value['phone'],
        mobile: this.formUserInformations.value['mobile'],
        addr: {
          addr: this.formUserInformations.value['adresse'],
          postal: this.formUserInformations.value['code'],
          city: this.formUserInformations.value['ville']
        }
      };
      this.profilInformationsService.updateProfileInformationsToServer({ userInfo: updateInfo }).subscribe(
        () => {
          this.loading = false;
          this.submitted = false;
          this.nextStep();
        },
        () => this.displayError()
      );
    }
  }

  getCGV() {
    this.profilInformationsService.getDocumentCGV().subscribe(res => {
      window.open(res as string, '_blank');
    });
  }

  public closeDialog() {
    this.openeUpdateDialog = false;
  }

  public backToPrevStep() {
    this.backStep.emit(false);
  }
  public nextStep() {
    this.validation.emit(true);
  }

  onKey(event: any) {
    of(event)
      .pipe(
        throttleTime(500),
        distinctUntilChanged()
      )
      .subscribe(sirenInfo => {
        this.profilInformationsService.getClientBySiren((sirenInfo.target as HTMLInputElement).value).subscribe(
          res => {
            this.existSiren = true;
            this.errorMsg = `Ce compte existe déjà. Si vous faîtes partie de l'organisation ${
              res.organization_name
            } de l'organisation veuillez
            prendre contact avec le responsable formation de votre organisation ou avec notre référent:
             ${res.firstName + ' ' + (res.name || '').toUpperCase()}
             email: ${res.mail}`;
          },
          () => {
            this.existSiren = false;
          }
        );
      });
  }
}
